module.exports = __webpack_public_path__ + "static/slide3-9525e0e552884266bca862126a416448.jpg";